import React from 'react';
import { LinearProgress } from '@material-ui/core';

const Loading: React.FC = () => {
	return (
		<LinearProgress style={{height: 5}} />
	);
}

export default Loading;